module.exports = __webpack_public_path__ + "10f6e04eb2bc7482efb23acc028fc0c2.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-account/details/account-details.html
// module id = 1900
// module chunks = 0